import setCSSVar from "../utils/setCssVar";

// data-animation: attaches the intersection observer to the element
// - zoom-in
// - fade-in
// - fade-in-up
// - slide-in
// - see _animations-controller.scss for more
// data-animation-delay: delay before the animation starts, specify unit - default is 0
// data-animation-duration: duration of the animation, specify unit - default is 1s
// data-animation-breakpoint: the breakpoint at which the animation should be applied, mobile-first - default is 0
export default class AnimationsController {
  constructor(elem) {
    this.elem = elem;

    this.animatedElements = this.elem.querySelectorAll('[data-animation]');
    this.currentBreakpoint = null;
    this.observers = [];
  }

  init() {
    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion) return;
    
    this.currentBreakpoint = window.outerWidth;
    const observerOptions = {
      root: document,
      rootMargin: "-25% 0px -25% 0px",
      threshold: .5
    };


    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const isPreload = document.body.classList.contains('preload');
          if (isPreload) return;
          entry.target.classList.add('entered');
          observer.unobserve(entry.target);
        }
      }, observerOptions);
    });

    this.animatedElements.forEach(element => {
      const breakpoint = parseInt(element.dataset.animationBreakpoint, 10) || 0;

      if (this.currentBreakpoint < breakpoint) {
        // remove all data attributes and do not attach observer
        element.removeAttribute('data-animation');
        element.removeAttribute('data-animation-delay');
        element.removeAttribute('data-animation-duration');
        return;
      }

      const delay = element.dataset.animationDelay;
      const duration = element.dataset.animationDuration;
      const easing = element.dataset.animationEasing;

      if (delay) setCSSVar(element, '--animation-delay', delay);
      if (duration) setCSSVar(element, '--animation-duration', duration);
      if (easing) setCSSVar(element, '--animation-easing', easing);

      observer.observe(element);
      this.observers.push(observer);
    });

  }
}